import { LucideAlertTriangle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Text, XStack, YStack, Button } from 'tamagui';
import { tokens } from 'tamagui-config';

import { GlowBackground } from '../../../components/common/GlowBackground';
import { LoadingOverlay } from '../../../components/common/LoadingOverlay';
import {
  useElectricalAlertContext,
  ElectricalAlertState,
} from '../../../contexts/ElectricalAlertContext';

export const ElectricalAlertContent = () => {
  const { t } = useTranslation();
  const { alertState, alertMessage, onRequestService, onClearAlert, loading } =
    useElectricalAlertContext();

  let icon, color, showActions, message;
  switch (alertState) {
    case ElectricalAlertState.ServiceRequested:
      icon = <LucideAlertTriangle size={80} color={tokens.color.deltaBlue} />;
      color = tokens.color.deltaBlue;
      showActions = false;
      message = t('electrical.serviceRequested');
      break;
    case ElectricalAlertState.Alert:
      icon = <LucideAlertTriangle size={80} color={tokens.color.warningRed} />;
      color = tokens.color.warningRed;
      showActions = true;
      message = alertMessage || t('electrical.criticalAlert');
      break;
    case ElectricalAlertState.NoAlert:
    default:
      icon = <LucideAlertTriangle size={80} color={tokens.color.successGreen} />;
      color = tokens.color.successGreen;
      showActions = false;
      message = t('electrical.allSystemsNominal');
      break;
  }

  return (
    <YStack flex={1} gap="$4">
      <LoadingOverlay isVisible={loading} />

      {!loading && (
        <>
          <GlowBackground color={color} />
          <YStack flex={1} justifyContent="center">
            <XStack gap="$4" alignItems="center">
              <YStack width={80} height={80}>
                {icon}
              </YStack>
              <Text color={color} fontSize="$9.5">
                {message}
              </Text>
            </XStack>
          </YStack>
          {showActions && (
            <XStack gap="$4">
              <Button
                flex={1}
                height={72}
                backgroundColor="$deltaBlue"
                borderRadius="$10"
                onPress={onRequestService}
                disabled={loading}>
                <Text color="$white12" fontSize="$8.5">
                  {t('electrical.requestService')}
                </Text>
              </Button>
              <Button
                flex={1}
                height={72}
                backgroundColor="$transparent"
                borderRadius="$10"
                borderWidth={2}
                borderColor="$deltaBlue"
                onPress={onClearAlert}
                disabled={loading}>
                <Text color="$white12" fontSize="$8.5">
                  {t('electrical.clearAlert')}
                </Text>
              </Button>
            </XStack>
          )}
        </>
      )}
    </YStack>
  );
};
